import { Grid, Link, Box, Typography } from '@mui/material';
import { sxStyle } from './styles';
import argentina from '@shared/assets/footer/argentina.svg';
import faevyt from '@shared/assets/footer/logos-footer-faevyt.svg';
import acav from '@shared/assets/footer/acav.svg';
import iata from '@shared/assets/footer/iata.svg';

const FooterExternalLogos = ({ copyrights }) => (
  <Grid item xs={12} lg={8} sx={sxStyle.linksAndCopy}>
    {copyrights && (
      <Typography sx={sxStyle.copyrightText}>{copyrights}</Typography>
    )}
    <Grid sx={sxStyle.footerLogosContainer}>
      {[iata, faevyt, acav, argentina].map((logo, i) => (
        <Link
          key={`footer-logo-${i}`}
          href="#"
          target="_blank"
          rel="noopener"
          sx={sxStyle.logoLink}
        >
          <Box component="img" src={logo} sx={sxStyle.footer_logo} />
        </Link>
      ))}
    </Grid>
  </Grid>
);

export default FooterExternalLogos;
